 <bzg-modal-header>
      <span class="bzg-modal__header__title bmc-delete-alert__title">{{ data.title | translate | uppercase }}</span>
    </bzg-modal-header>
    <bzg-modal-content class="bmc-delete-alert__body">
      <span [innerHTML]="data.message | translate"></span>
    </bzg-modal-content>
    <bzg-modal-footer class="bmc-delete-alert__footer">
      <bzg-button-secondary class="bz-space--inline-m" (click)="close()">{{ 'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
      <bzg-button-primary color="error" (click)="save()">{{ 'GLOBAL.ACCEPT' | translate}}</bzg-button-primary>
    </bzg-modal-footer>
